module.exports = __webpack_public_path__ + "img/plane.7c8d7f82.jpg";